import httpClient from "./httpClient";

export const districtApi = {
    list: async () => {
        return httpClient.get("district")
    },
}